import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatAccordion } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { ManagerExecutionService } from '../../services/manager.service';
import { DatePipe } from '@angular/common';
import { OperatorExecutionService } from 'src/app/services/operator-execution.service';
import Swal from 'sweetalert2';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { EditBtnRenderer } from 'src/app/edit-action-btn-renderer.component';
import { DeleteBtnRenderer } from 'src/app/delete-action-btn-renderer.component';
import * as moment from 'moment';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TechnicianService } from 'src/app/services/technician.service';
import { CILMasterService } from 'src/app/services/cil-master-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { CommonService } from 'src/app/services/common.service';
import { BaseApi } from 'src/backend/api/base-api';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { PermissionService } from 'src/backend/services/permission.service';
import { QRCodeComponent } from 'src/app/screens/qrCodeComponents/qrcode/qrcode.component';
import { MatDialog } from '@angular/material/dialog';
import { TechScoreService } from 'src/app/services/tech-score.service';
import { ActionEditDeleteViewBtnRendererOperator } from 'src/app/action-edit-delete-view-btn-renderer-operator.component';
import { AnalyticalToolsService } from 'src/app/services/analytical-tools.service';
import { AtStagesNcrComponent } from 'src/app/analytical-tools/at-stages-ncr/at-stages-ncr.component';

@Component({
  selector: 'app-operator-execution',
  templateUrl: './operator-execution.component.html',
  styleUrls: ['./operator-execution.component.scss'],
})
export class OperatorExecutionComponent implements OnInit {
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  woStatus: any = [];
  woType = [
    { id: 1, title: 'Electrical' },
    { id: 2, title: 'Mechanical' },
  ];
  failMode = [
    { id: 1, title: 'Mode 1' },
    { id: 2, title: 'Mode 2' },
  ];
  sparePart = [
    { id: 0, title: 'No' },
    { id: 1, title: 'Yes' },
  ];
  QualityareaColumns: string[] = [
    'WOId',
    'LineId',
    'TimeStamp',
    'WOStatus',
    'WOType',
    'FailureMode',
    'SpareParts',
    'Remark',
    'UploadPicture',
    'action',
  ];
  dataSource = new MatTableDataSource();
  @ViewChild(MatAccordion) accordion: MatAccordion = new MatAccordion();
  @ViewChild(MatSort) sort: MatSort = new MatSort();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('workPermitDialog') workPermitDialog!: TemplateRef<any>;
  opratorList: any = {
    LineId: 0,
    TimeStamp: 0,
    WOId: 0,
    WOStatus: '',
    WOType: '',
    FailureMode: '',
    SpareParts: '',
    Remarks: 0,
    UploadPicture: '',
    RequestedBy: 0,
    userList: [],
  };
  spinnerText: string = '';
  WOStatus: any = '';
  WOType: any = '';
  FailMode: any = '';
  SpareParts: any = '';
  operator: any;
  userList: any = [];
  userListReq: any = [];
  breadcrumList!: any;
  permisson!: any;
  HeaderData: any = { Group: '', Plant: '' };
  HeaderForm!: FormGroup;
  minDate: any;
  maxDate: any;
  GroupList: any = [];
  filteredGroupList: any = [];
  PlantList: any = [];
  filteredPlantList: any = [];
  AllTool: any = [];
  GroupTempList: any = [];
  PlantTempList: any = [];
  technicianList: any = [];
  dateFilter: any = { From: '', To: '' };
  frmDate: any;
  tDate: any;
  ExportOperatorList: any = [];
  isSuperAdmin: boolean;
  qrCodeData: string = '';
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  frameworkComponents: any;
  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;

  gridOptions: any = {
    defaultColDef: {
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      minWidth: 225,
      filter: 'agSetColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
    popupParent: document.querySelector('body'),
  };
  lang: any;
  isAccess = ApplicationPermission.OPERATOR_EXECUTION_WINDOW_ACCESS;
  isWrite = ApplicationPermission.OPERATOR_EXECUTION_WINDOW_CREATE;
  isUpdate = ApplicationPermission.OPERATOR_EXECUTION_WINDOW_UPDATE;
  isDelete = ApplicationPermission.OPERATOR_EXECUTION_WINDOW_DELETE;
  plantSession: any;
  groupSession: any;
  userSession: any;
  openCount: number;
  closedCount: number;
  completedCount: number;
  delayedCount: number;
  inProgressCount: number;
  reOpenCount: number;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private translater: TranslaterService,
    private translate: TranslateService,
    private employeeService: EmployeeService,
    private dialog: MatDialog,
    private techScore: TechScoreService,
    private baseApi: BaseApi,
    private permissionService: PermissionService,
    private analyticalToolsService: AnalyticalToolsService,
    private technicianService: TechnicianService,
    private enterpriseGroupService: EnterPriseGroupService,
    public managerExecutionService: ManagerExecutionService,
    public datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private operatorExecutionService: OperatorExecutionService,
    private toaster: ToastrService,
    private userManagementService: UserManagementService,
    private commonService: CommonService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
    this.frameworkComponents = {
      actionEditDeleteViewBtnRendererOperator:
        ActionEditDeleteViewBtnRendererOperator,
    };
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'actionEditDeleteViewBtnRendererOperator',
        // minWidth: 200,
        cellRendererParams: {
          onClickEdit: this.editRow.bind(this),
          onClickDelete: this.deleteRow.bind(this),
          onClickView: this.viewRow.bind(this),
          // onClickViewWorkPermit: this.viewWorkPermitRow.bind(this),
          onClickQRCode: this.QRRow.bind(this),
          // onClickRCA: this.onClickRCA.bind(this),
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      // {
      //   headerName: 'WP#',
      //   field: 'Work Permit',
      //   maxWidth: 100,
      //   cellStyle: function (params: any) {
      //     if (params.value == 'Approved') {
      //       return { color: 'white', backgroundColor: 'green' };
      //     } else if (params.value == 'Pending') {
      //       return { color: 'black', backgroundColor: 'yellow' };
      //     } else if (params.value == 'Rejected') {
      //       return { color: 'white', backgroundColor: 'red' };
      //     } else {
      //       return { color: 'white', backgroundColor: 'grey' };
      //     }
      //   },
      // },
      {
        headerName: 'WO Status',
        field: 'WOStatus',
        cellStyle: function (params: any) {
          if (params.value == 'Complete' || params.value == 'Close') {
            return { color: 'white', backgroundColor: 'green' };
          } else if (params.value == 'In Progress') {
            return { color: 'black', backgroundColor: 'orange' };
          } else {
            params.value = params.value == 'ReOpen' ? 'ReOpened' : params.value;
            return { color: 'white', backgroundColor: 'red' };
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Id',
        field: 'displayWOId',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Detail',
        field: 'Remark',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
      },
      {
        headerName: 'RCA',
        minWidth: 200,
        field: 'rca',
        cellStyle: function (params: any) {
          const atIntegration = params?.data?.ATIntegration;

          if (atIntegration) {
            const isCompleted =
              atIntegration.ATStatus?.toLowerCase() === 'completed';
            return {
              color: 'blue',
              'text-decoration': 'underline',
              cursor: 'pointer',
              backgroundColor: isCompleted ? '#1de71d' : '#f3f332',
            };
          }
        },
      },

      {
        headerName: 'Manager Remarks',
        field: 'managerExc.ManagerRemarks',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
      },
      {
        headerName: 'Technician Remarks',
        field: 'techExc.Remarks',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
      },
      {
        headerName: 'WO Type',
        field: 'WOType',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Line/Area',
        field: 'LineId',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Creation Stamp',
        minWidth: 180,
        field: 'TimeStamp',
        cellRenderer: function (params: any) {
          let html = params && params.value;
          return (html = moment(html).format('DD/MM/YYYY hh:mm a'));
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },

      {
        headerName: 'Failure Mode',
        field: 'FailureMode',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Parts',
        field: 'SpareParts',
        cellRenderer: function (params: any) {
          let html = '';
          if (params.value == 1) {
            html = `Required`;
          } else {
            html = `Not Required`;
          }
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Parts Code',
        field: 'managerExc.SparePartCode',
      },
      {
        headerName: 'Machine Breakdown',
        field: 'MachineBreakdown',
        valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
      },
      {
        headerName: 'Assigned Technician',
        field: 'managerExc.assignUsername',
        //  headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: ' Technician StartDate',
        field: 'techExc.StartTime',
        valueFormatter: function (params: any) {
          if (params.value) {
            return moment(params.value).format('DD/MM/YYYY hh:mm a');
          } else {
            return;
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Technician CompleteDate',
        field: 'techExc.CompleteTime',
        valueFormatter: function (params: any) {
          if (params.value) {
            return moment(params.value).format('DD/MM/YYYY hh:mm a');
          } else {
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];
  }

  ngOnInit(): void {
    this.getLangWords();
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.woStatus = this.operatorExecutionService.getWoStatusList();
    this.HeaderForm = this.fb.group({
      fromDate: new FormControl(null),
      toDate: new FormControl(null),
    });
    const fromDT = new Date();
    fromDT.setDate(fromDT.getDate() - 1);
    fromDT.setHours(0, 0, 0, 0);
    const toDT = new Date();
    this.dateFilter = {
      From: fromDT,
      To: toDT,
    };

    let woHeaderData = this.operatorExecutionService.getWOHeaderData();
    if (woHeaderData) {
      if (woHeaderData.FromDate) this.dateFilter.From = woHeaderData.FromDate;
      if (woHeaderData.ToDate) this.dateFilter.To = woHeaderData.ToDate;
    }
    this.getTechnicianList();
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }
  getTechnicianList(): void {
    this.spinner.show();
    this.spinnerText = 'Fetching Technician Data';
    const key = {
      PlantCode: this.plantSession?.plantCode,
      GroupCode: this.groupSession?.groupCode,
    };
    this.technicianService.getTechnicianList(key).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.technicianList = [];
        if (res.data && res.data.length) {
          for (let user of res.data) {
            const usr = this.technicianList.find(
              (usr: any) => usr.UserId == user.UserId
            );
            if (!usr) this.technicianList.push(user);
          }
        }
        this.getUserList();
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.error.message);
      }
    );
  }
  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.spinner.show();
    this.employeeService.getAllEmployees().subscribe(
      (res: any) => {
        if (res) {
          this.userListReq = res;
          this.userList = this.userListReq.slice();
          this.getOperatorData();
          this.spinner.hide();
        } else {
          this.userList = [];
          this.spinner.hide();
          this.setUserName();
        }
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error('Error', err.message);
      }
    );
  }
  getOperatorData() {
    const obj = {
      UserId: this.userSession?.userCode,
      woid: 0,
      From: this.dateFilter.From,
      To: this.dateFilter.To,
      groupCode: this.groupSession?.groupCode,
      plantCode: this.plantSession?.plantCode,
    };
    this.spinnerText = 'Fetching Operator Data';
    this.spinner.show();
    this.managerExecutionService.getOperatorData(obj).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.MEWo) {
          this.opratorList = res.MEWo;
          this.woStatus = this.operatorExecutionService.getWoStatusList();
          this.openCount = 0;
          this.closedCount = 0;
          this.completedCount = 0;
          this.delayedCount = 0;
          this.reOpenCount=0;
          this.inProgressCount = 0;
          for (let i = 0; i < this.opratorList.length; i++) {
            this.WOStatus = this.woStatus.find(
              (element: any) => element.id == parseInt(res.MEWo[i].WOStatus)
            );
            this.opratorList[i].WOStatus =
              this.WOStatus && this.WOStatus.title ? this.WOStatus.title : '';
            this.opratorList[i].WOType = this.opratorList[i].WOType.Name;
            this.opratorList[i].FailureMode =
              this.opratorList[i].FailureMode.Name;
            var line = res.MEWo[i].line ? res.MEWo[i].line?.plDesc : '';
            var unit = res.MEWo[i].units ? res.MEWo[i].units?.puDesc : '';
            var assem = res.MEWo[i].assembly
              ? res.MEWo[i].assembly?.assblyDesc
              : '';
            var subaseem = res.MEWo[i].subAssembly
              ? res.MEWo[i].subAssembly?.sAsblyDesc
              : '';
            var com = res.MEWo[i].component
              ? res.MEWo[i].component?.componentName
              : '';
            this.opratorList[i].UploadPicture = res.MEWo[i].UploadPicture
              ? res.MEWo[i].UploadPicture.split(',')[0]
              : '';
            this.opratorList[i].LineId =
              line + '-' + unit + '-' + assem + '-' + subaseem + '-' + com;
            this.opratorList[i].displayWOId = res.MEWo[i].WOId;
            this.opratorList[i].rca = res.MEWo[i].ATIntegration
              ? `AT-RCA-${res.MEWo[i].ATIntegration.HeaderId}`
              : '';
            this.opratorList[i].WOId = res.MEWo[i].ID;
            this.opratorList[i].TimeStamp = this.opratorList[i].TimeStamp;
            this.opratorList[i].CreatedAt = this.opratorList[i].CreatedAt;
            this.opratorList[i].ClosedAt = this.opratorList[i].ClosedAt;

            this.opratorList[i].assignUser =
              this.opratorList[i].managerExc &&
                this.opratorList[i].managerExc.assignUser
                ? this.opratorList[i].managerExc.assignUser
                : '';

            if (this.opratorList[i].techExc) {
              this.opratorList[i].techExc.StartTime =
                this.opratorList[i].techExc.StartTime;
              this.opratorList[i].techExc.CompleteTime =
                this.opratorList[i].techExc.CompleteTime;
            }

            switch (this.opratorList[i].WOStatus) {
              case 'Open':
                this.openCount++;
                break;
              case 'Close':
                this.closedCount++;
                break;
              case 'Complete':
                this.completedCount++;
                break;
              case 'Delay':
                this.delayedCount++;
                break;
                 case 'ReOpen':
                this.reOpenCount++;
                break;
              case 'In Progress':
                this.inProgressCount++;
                break;
            }
          }

          this.rowData = [];
          this.rowData = this.opratorList;
          this.autoSizeAllColumns();
          this.rowData.map((row: any) => {
            if (
              row.createdBy === this.userSession?.userCode ||
              this.isSuperAdmin === true
            ) {
              row.IsWrite = this.isWrite;
            } else {
              row.IsWrite = false;
            }
          });
          this.setUserName();
        }
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }

  autoSizeAllColumns() {
    this.gridApi.setRowData(this.rowData);
    this.gridColumnApi.autoSizeAllColumns();
  }

  setUserName() {
    if (
      this.userList &&
      this.userList.length &&
      this.opratorList &&
      this.opratorList.length
    ) {
      for (let operator of this.opratorList) {
        let assignedUserNames = '';
        if (operator.assignUser) {
          operator.assignUser = operator.assignUser
            .split(',')
            .map((userId) => userId);
          if (operator.assignUser.length > 0) {
            const assignedUsers = operator.assignUser.map((userId) => {
              return this.userList.find((usr) => usr.UserId === userId);
            });
            assignedUserNames = assignedUsers
              .map((usr) => usr.fullName)
              .join('/ ');
          }
        }
        operator.assignedUserName = assignedUserNames
          ? assignedUserNames
          : 'Not Assigned Yet';

        const reqUser = this.userListReq.find(
          (usr: any) => usr.UserId == operator.RequestedBy
        );
        operator.requestedUserName = reqUser
          ? reqUser.fullName
          : operator.RequestedBy === 100001
            ? 'Admin'
            : '';
      }
      this.rowData = this.opratorList;
    }
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  getFilterData() {
    if (
      !this.groupSession?.groupCode ||
      !this.plantSession?.plantCode ||
      !this.dateFilter.To ||
      !this.dateFilter.From
    ) {
      this.toaster.warning('warn', 'Date Fields Is required');
      this.rowData = [];
      return;
    } else if (this.dateFilter.From >= this.dateFilter.To) {
      return;
    } else {
      this.minDate = this.dateFilter.From;
      this.maxDate = this.dateFilter.To;
      this.getOperatorData();
    }
  }

  addOperator() {
    this.managerExecutionService.setManagerData('');
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      FromDate: this.dateFilter.From,
      ToDate: this.dateFilter.To,
    };
    this.operatorExecutionService.setWOHeaderData(data);

    this.router.navigate(['/PM/operator-form']);
  }

  ExportTOExcel() {
    this.ExportOperatorList = [];
    console.log(this.rowData, 'rpwdata');
    if (this.rowData && this.rowData.length) {
      for (const row of this.rowData) {
        const ExportData = {
          ['WO Status']: row && row.WOStatus ? row.WOStatus : '',
          ['WO ID']: row && row.WOId ? row.WOId : '',
          ['WO Detail']: row && row.Remark ? row.Remark : '',
          ['RCA']:
            row && row.ATIntegration && row.ATIntegration.HeaderId
              ? `AT-RCA-${row.ATIntegration.HeaderId}`
              : '',
          ['WO Creation Date']:
            row && row.TimeStamp
              ? moment(row.TimeStamp).format('DD/MM/YYYY hh:mm a')
              : '',
          ['WO Type']: row && row.WOType ? row.WOType : '',
          ['Failure Mode']: row && row.FailureMode ? row.FailureMode : '',
          ['Group']: row && row.Group.egDesc ? row.Group.egDesc : '',
          ['Line/Area']: row && row.LineId ? row.LineId : '',
          ['Spare Parts']: row && row.SpareParts ? 'Required' : 'Not Required',
          ['Technician StartDate']:
            row && row.techExc?.StartTime
              ? moment(row.techExc?.StartTime).format('DD/MM/YYYY hh:mm a')
              : '',
          ['Technician CompleteDate']:
            row && row.techExc?.CompleteTime
              ? moment(row.techExc?.CompleteTime).format('DD/MM/YYYY hh:mm a')
              : '',
        };
        this.ExportOperatorList.push(ExportData);
      }
    } else {
      this.ExportOperatorList = [
        {
          ['WO Status']: '',
          ['WO ID']: '',
          ['WO Detail']: '',
          ['RCA']: '',
          ['WO Type']: '',
          ['WO Creation Date']: '',
          ['Group']: '',
          ['Line/Area']: '',
          ['Failure Mode']: '',
          ['Spare Parts']: '',
          ['Technician StartDate']: '',
          ['Technician CompleteDate']: '',
        },
      ];
    }
    const workBook = XLSX.utils.book_new();
    const WOSheet = XLSX.utils.json_to_sheet(this.ExportOperatorList);
    XLSX.utils.book_append_sheet(workBook, WOSheet, 'Work Order');
    XLSX.writeFile(workBook, `Work Order List.xlsx`);
  }

  editRow(element: any) {
    if (this.permissionService.isUserHasPermission(this.isUpdate)) {
      element.rowData.isView = false;
      this.managerExecutionService.setManagerData(element.rowData);
      this.managerExecutionService.setUserData(this.opratorList.userList);
      const data = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
        FromDate: this.dateFilter.From,
        ToDate: this.dateFilter.To,
      };
      this.operatorExecutionService.setWOHeaderData(data);
      this.router.navigate(['/PM/operator-form']);
    }
  }

  viewRow(element: any) {
    if (this.permissionService.isUserHasPermission(this.isAccess)) {
      element.rowData.isView = true;
      this.managerExecutionService.setManagerData(element.rowData);
      this.managerExecutionService.setUserData(this.opratorList.userList);
      const data = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
        FromDate: this.dateFilter.From,
        ToDate: this.dateFilter.To,
      };
      this.operatorExecutionService.setWOHeaderData(data);
      this.router.navigate(['/PM/operator-form']);
    }
  }

  viewWorkPermitRow(element: any) {
    this.toaster.success('WorkPermit', 'WorkPermit Here');
    if (this.permissionService.isUserHasPermission(this.isAccess)) {
      const dialogRef = this.dialog.open(this.workPermitDialog, {
        width: '1000px',
        data: { element }, // Pass data to the dialog
      });
    }
  }

  deleteRow(element: any) {
    if (this.permissionService.isUserHasPermission(this.isDelete)) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to Delete WO!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result: any) => {
        if (result.value) {
          this.spinner.show();
          this.operatorExecutionService
            .deleteOperaterData(element.rowData.WOId)
            .subscribe(
              (success) => {
                this.toaster.success(`Data Deleted Successfully`, 'Success', {
                  timeOut: 3000,
                });
                this.spinner.hide();
                this.getOperatorData();
              },
              (error) => {
                this.spinner.hide();
                this.toaster.error('Error', error.error.message);
              }
            );
        }
      });
    }
  }

  onFilterChanged(event: any) {
    this.gridOptions.api.setQuickFilter(event.value);
  }

  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.autoSizeAllColumns();
  }

  cellClicked(params: any): void {
    const col = params.colDef.field;
    if (col == 'rca') {
      if (params?.value !== '') {
        const headerId = params.data.ATIntegration.HeaderId ?? 0;
        this.analyticalToolsService.setHeaderId(headerId);
        const dialogRef = this.dialog.open(AtStagesNcrComponent, {
          height: '100%',
          width: '100%',
          panelClass: 'full-screen-modal-RCA',

          data: {
            InitProbStatement: params.data.Remark ? params.data.Remark : '',
            ncrIdDesc: params.data.Remark ? params.data.Remark : '',
            tableId: params.data.WOId,
            moduleId: 9,
            patchForm: headerId != 0 ? true : false,
            patchHeader: true,
            Group: this.groupSession.groupCode,
            Plant: this.plantSession.plantCode,
            headerId: headerId,
            isView: true,
            isCreate: false,
          },
        });
        dialogRef.afterClosed().subscribe((data) => {
          this.analyticalToolsService.setHeaderId(0);
          this.getOperatorData();
        });
      }
    }
  }

  // onClickRCA(params: any): void {
  //   const atData = params.rowData.ATIntegration;
  //   const headerId = atData ? atData.HeaderId : 0;
  //   this.analyticalToolsService.setHeaderId(headerId);
  //   const dialogRef = this.dialog.open(AtStagesNcrComponent, {
  //     height: '100%',
  //     width: '100%',
  //     panelClass: 'full-screen-modal-RCA',

  //     data: {
  //       InitProbStatement: params.rowData.Remark ? params.rowData.Remark : '',
  //       ncrIdDesc: params.rowData.Remark ? params.rowData.Remark : '',
  //       tableId: params.rowData.displayWOId,
  //       moduleId: 9,
  //       patchForm: headerId != 0 ? true : false,
  //       patchHeader: true,
  //       Group: this.groupSession.groupCode,
  //       Plant: this.plantSession.plantCode,
  //       headerId: headerId,
  //       hideTabs: false,
  //       isCreate: true,
  //       isView: false,
  //     },
  //   });
  //   dialogRef.afterClosed().subscribe((data) => {
  //     this.analyticalToolsService.setHeaderId(0);
  //     this.getOperatorData();
  //   });
  // }

  QRRow(element: any) {
    if (!element.rowData?.managerExc?.assignUser) {
      this.toaster.warning('Warning', 'Technician Not Assigned');
      return;
    }
    this.spinner.show();
    const getImage = {
      plantId: this.HeaderData.Plant,
      woId: parseInt(element.rowData?.displayWOId),
    };

    this.techScore.getTechnicianImageAndName(getImage).subscribe(
      (res: any) => {
        this.spinner.hide();
        const datePipe = new DatePipe('en-US');

        const qrData = {
          woId: element.rowData?.WOId,
          woDetails: element.rowData?.Remark,
          line: element.rowData?.line?.plDesc,
          machine: element.rowData?.units?.puDesc,
          assembly: element.rowData?.assembly?.assblyDesc,
          subAssembly: element.rowData?.subAssembly?.sAsblyDesc,
          component: element.rowData?.component?.componentName,
          failureMode: element.rowData?.FailureMode,
          woType: element.rowData?.WOType,
          woStatus: element.rowData?.WOStatus,
          sparePart:
            element.rowData?.SpareParts === 0 ? 'Not Required' : 'Required',
          createdBy: element.rowData?.CreatedByName,
          priority: element.rowData?.managerExc?.Priority?.Name,
          priorityColor: element.rowData?.managerExc?.Priority?.Color,
          createdAt: element.rowData?.CreatedAt
            ? datePipe.transform(element.rowData?.CreatedAt, 'dd/MM/yyyy')
            : null,
          assignedTechnicianTime: element.rowData?.managerExc
            ?.AssignTechnicianTimeStamp
            ? datePipe.transform(
              element.rowData?.managerExc?.AssignTechnicianTimeStamp,
              'dd/MM/yyyy hh:mm a'
            )
            : null,
        };
        this.qrCodeData = JSON.stringify(qrData);
        const key = {
          data: this.qrCodeData,
          fileName: 'QR Code',
          technicianList: res ? res : '',
          isTechnician: false,
        };
        this.dialog.open(QRCodeComponent, {
          panelClass: 'custom-dialog-container',
          minWidth: '600px',
          height: '90%',
          disableClose: true,
          data: key,
        });
      },
      (error) => {
        this.spinner.hide();
        this.toaster.error('Error', error.error.message);
      }
    );
  }
}
